import gql from 'graphql-tag';

export const FRAGMENT_BRAND_VOICE = gql`
  fragment BrandVoice on BrandVoice {
    id
    name
  }
`;

export const FRAGMENT_USER_PROJECT_BRAND_VOICE = gql`
  fragment UserProjectBrandVoice on UserProjectBrandVoice {
    generationTool
    key
    brandVoice {
      id
      name
    }
  }
`;
